import script from "./DoctorConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorConfig.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorConfig.vue?vue&type=style&index=0&id=32848314&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32848314"]])

export default __exports__